export const FETCH_LISTING_APPLICATIONS_SUCCESS = 'FETCH_LISTING_APPLICATIONS_SUCCESS';
export const FETCH_LISTING_APPLICATIONS_FAILURE = 'FETCH_LISTING_APPLICATIONS_FAILURE';
export const FETCH_APPLICANTS_DATA_SUCCESS = 'FETCH_APPLICANTS_DATA_SUCCESS';
export const FETCH_APPLICANTS_DATA_FAILURE = 'FETCH_APPLICANTS_DATA_FAILURE';
export const FETCH_ID_VERIFICATION_STATUS_SUCCESS = 'FETCH_ID_VERIFICATION_STATUS_SUCCESS';
export const FETCH_TERMS_STATUS_SUCCESS = 'FETCH_TERMS_STATUS_SUCCESS';
export const UPDATE_IS_ID_VERIFYING = 'UPDATE_IS_ID_VERIFYING';
export const UPDATE_ON_BOARDING_PAGE_VIEWED = 'UPDATE_ON_BOARDING_PAGE_VIEWED';
export const UPDATE_REDUX_ENROLLMENT_STATUS = 'UPDATE_REDUX_ENROLLMENT_STATUS';
export const UPDATE_INVITE_INFO_FROM_LEAD_INQUIRY = 'UPDATE_INVITE_INFO_FROM_LEAD_INQUIRY';
export const UPDATE_LISTING_RENT = 'UPDATE_LISTING_RENT';
export const LISTING_APPLICATIONS_TAB_LOADING_STATUS_UPDATE = 'LISTING_APPLICATIONS_TAB_LOADING_STATUS_UPDATE';
export const APPLICATION_REVIEW_LOADING_STATUS_UPDATE = 'APPLICATION_REVIEW_LOADING_STATUS_UPDATE';
export const APPLICATIONS_BROWNOUT_WARNING_MESSAGE_UPDATE = 'APPLICATIONS_BROWNOUT_WARNING_MESSAGE_UPDATE';
export const SCREENING_BROWNOUT_UPDATE = 'SCREENING_BROWNOUT_UPDATE';
export const PARENT_APP_INFO_RECEIVED = 'PARENT_APP_INFO_RECEIVED';
export const SHARED_REPORTS = 'SHARED_REPORTS';
export const RECEIVE_BUSINESS_VERIFICATION_DATA = 'RECEIVE_BUSINESS_VERIFICATION_DATA';
export const UPDATE_REPORTS_LOADING_STATUSES = 'UPDATE_REPORTS_LOADING_STATUSES';
export const ENROLLMENT_LOADING_STATUS_UPDATE = 'ENROLLMENT_LOADING_STATUS_UPDATE';
